import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authorities',
  templateUrl: './authorities.page.html',
  styleUrls: ['./authorities.page.scss'],
})
export class AuthoritiesPage implements OnInit {
  isLoading = false;
  authoritiesList = [];
  filteredAuthoritiesList = [];
  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.isLoading = true;
    this.http.get<any[]>('assets/authorities.json').subscribe(data => {
      this.authoritiesList = data;
      this.filteredAuthoritiesList = [...this.authoritiesList];
      this.isLoading = false;
    });
  }

  onFilterChanged(searchBar) {
    if (searchBar.value.trim().length <= 0) {
      this.filteredAuthoritiesList = [
        ...this.authoritiesList,
      ];
    }
    this.filteredAuthoritiesList = [
      ...this.authoritiesList
        .filter((b) =>
          b.Municipality_Name_EN.toLowerCase().includes(searchBar.value.toLowerCase()) ||
          b.Municipality_Name_AR.toLowerCase().includes(searchBar.value.toLowerCase())
        )
      ,
    ];
  }

  phones(a: any): string[] {
    if (!a?.Municipality_Phone) return [];
    // split by spaces, clean up, and de-dupe
    const parts = a.Municipality_Phone
      .split(' ')
      .map(s => s.trim())
      .filter(Boolean);
    return parts;
  }

  call(phone: string) {
    window.location.href = `tel:${phone}`;
  }

  formatNumber(phone: string): string {
    if (phone.length === 8) {
      return `${phone.slice(0, 2)} ${phone.slice(2, 5)} ${phone.slice(5)}`;
    }
    else return phone;
  }

  formatName(authority: any): string {
    if (authority.Municipality_Name_EN === "Internal Security Forces (ISF)" || authority.Municipality_Name_EN === "Ministry of Algiculture") {
      return `${authority.Municipality_Name_EN} - ${authority.Municipality_Name_AR}`;
    }
    return `${authority.Municipality_Name_EN} Municipality - بلدية ${authority.Municipality_Name_AR}`;
  }
}
